/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AssignmentTemplate } from './AssignmentTemplate';
import { FileTreeWithKey } from './FileTreeWithKey';
const AssignmentTemplateAsJSONWithS3Parser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['files', /* #__PURE__ */ parsers.maybeNull(FileTreeWithKey)],
]), AssignmentTemplate);
export class AssignmentTemplateAsJSONWithS3 extends AssignmentTemplate {
    static decode(input) {
        return AssignmentTemplateAsJSONWithS3Parser.decode(input).map(res => new AssignmentTemplateAsJSONWithS3(res));
    }
    static unsafeDecode(input) {
        return AssignmentTemplateAsJSONWithS3.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentTemplateAsJSONWithS3Parser.encode(data);
    }
    static schema() {
        return AssignmentTemplateAsJSONWithS3Parser.schema();
    }
}
